import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import JobContainer from 'components/jobs/container/JobContainer';
import NoOfJobsButton from 'components/noOfJobsButton';
import {
  COMPANY_COMPETITORS_FILTERS,
  COMPANY_JOBS_FITERS,
  FILTER_PARAMS,
  setupFilters,
} from 'components/zpFilter/filterUtils';
import { withFallbackToCompanyPaidJobs, withZippiaHistory } from 'hooks';
import CompanyDisclaimerSection from 'layouts/companyPage/companyDisclaimerSection';
import QuestionAndAnswerSection from 'layouts/section/questionAndAnswerSection';
import { surveyService } from 'services/surveyService';
import { dispatchCreateJobBucket } from 'store/jobs/actions';
import { openSignUpModal } from 'store/modals/actions';
import { buildCppSubpageUrl,JOB_BUCKET_GROUP } from 'utils';
import CompanyClusterFooter from 'widgets/clusterFooter/companyClusterFooter/CompanyClusterFooter';

import ContinueSurvey from '../components/continueSurvey';
import CompanyTimelineSection from '../layouts/companyHistoryPage/CompanyTimelineSection';
import SimilarCompaniesSection from '../layouts/companyHistoryPage/similarCompaniesSection';
import { companyService } from '../services/companyService';
import { CLUSTER_HEADER_CATEGORY, CPP_SUBPAGES } from '../utils/constant';
import BreadCrumbs from '../widgets/BreadCrumbs';
import ClusterHeader from '../widgets/clusterHeader';
import Meta from '../widgets/Meta';

const CompanyHistorySection = dynamic(
  () => import('../layouts/companyHistoryPage/CompanyHistorySection'),
  { ssr: false }
);

class CompanyHistoryPage extends Component {
  static async getInitialProps({ req, res }) {
    if (req) {
      return {
        data: res ? res.data : null,
        user: req ? req.user : null,
        locals: res ? res.locals : null,
      };
    }
    return window.__NEXT_DATA__.props.pageProps;
  }

  state = {
    companyHistory: null,
    merge_info: null,
    companyWikipediaPageURL: null,
  };

  componentDidMount() {
    const {
      data: {
        companyInfo: { companyID },
      },
      dispatchCreateJobBucket,
    } = this.props;

    companyService
      .getCompanyDetails(companyID)
      .then(({ companyHistory, merge_info, companyWikipediaPageURL }) => {
        this.setState({
          companyHistory,
          merge_info,
          companyWikipediaPageURL: Array.isArray(companyWikipediaPageURL)
            ? companyWikipediaPageURL?.[0]
            : companyWikipediaPageURL,
        });
      })
      .catch((err) => {
        console.error(err);
      });

    dispatchCreateJobBucket({ key: JOB_BUCKET_GROUP.CPP_COMPANY_JOBS_BUCKET });
    dispatchCreateJobBucket({ key: JOB_BUCKET_GROUP.CPP_FALLBACK_TO_PAID_JOBS });
    dispatchCreateJobBucket({ key: JOB_BUCKET_GROUP.CPP_SIMILAR_COMPANY_JOBS_BUCKET });
    dispatchCreateJobBucket({ key: JOB_BUCKET_GROUP.PAID_JOBS });
  }

  onOpenMainCppSurvey = (src = '', answer = {}) => {
    const { openSignUpModal, zippiaHistory } = this.props;

    const query = {
      survey_step: 'step1',
      survey: '036',
      src,
    };
    if (answer.answerCategory === 'location') {
      query.survey_step = 'step2';
      query.skipQuestion = [1];
    }
    openSignUpModal({
      ...query,
    }).then(() => {
      zippiaHistory.pushQuery(query);
      if (answer.answerCategory === 'location') {
        this.sendLocationResponse(answer);
      }
    });
  };

  sendLocationResponse = (answer) => {
    const { modals } = this.props;
    const { answerData = {} } = answer || {};
    const { displayValue = '', valueObj = {} } = answerData || {};
    if (!valueObj || !valueObj.state) {
      return;
    }
    let currentAnswer = displayValue;
    const { questionList, surveyFlow, survey, utm_campaign, surveyStartTimeStamp, surveyId } =
      modals.signUp;
    const surveyResponse = {
      questionId: questionList[0].question._id,
      surveyFlow,
      surveyName: survey,
      surveyId,
      surveyStep: '1',
      utm_campaign,
      surveyStartTimeStamp,
      timeStamp: Date.now(),
    };
    surveyResponse.answer = [currentAnswer] || [];
    return surveyService.sendSurveyResponse(surveyResponse);
  };

  setupCompanyCompetitorFilters = () => {
    const newFields = [];

    const { data } = this.props;

    const { competitors = [] } = data;

    const companies = competitors.map(({ companyID, companyNameCPS }) => ({
      displayName: companyNameCPS,
      value: companyID,
    }));

    COMPANY_COMPETITORS_FILTERS.forEach((filter) => {
      switch (filter.param) {
        case FILTER_PARAMS.COMPANY:
          newFields.push({
            valueRange: companies,
          });
          break;
        default:
          newFields.push({});
      }
    });
    return setupFilters(COMPANY_COMPETITORS_FILTERS, newFields);
  };

  render() {
    const {
      data,
      locals,
      mainBucketProps,
      hideMainJobBucket,
      similarCompanyJobsBucket,
      userLocation,
      jobListDismiss,
    } = this.props;

    const { companyHistory, merge_info, companyWikipediaPageURL } = this.state;

    const {
      metadata,
      companyInfo,
      competitors,
      companyTimeline,
      breadCrumbs = [],
      companyLocation,
      companyLocationLink,
      desktopDevice,
      criteria,
      footerSectionLinks,
      qnaData,
    } = data;

    const { UPDATED_TIME } = metadata;
    const lastUpdatedDate = dayjs(UPDATED_TIME).format('MMMM D, YYYY');

    const {
      companyNameCPS,
      companyFounders,
      companyFoundedDate,
      displayFlagOfCompanyJobsPage,
      companyJobsCount,
      companyLink,
    } = companyInfo;

    const showTimelineSection = companyTimeline && companyTimeline.length > 0;

    let mainBucketFilters = [...COMPANY_JOBS_FITERS];

    if (hideMainJobBucket && locals.displayPaidJobs.cppFallbackToPaidJobs)
      mainBucketFilters = mainBucketFilters.slice(1, 2);

    const showJobsCount = !!(displayFlagOfCompanyJobsPage && companyJobsCount);

    return (
      <div>
        <Meta {...metadata} />
        <ClusterHeader
          data={data}
          subPageName={CPP_SUBPAGES.HISTORY}
          clusterCategory={CLUSTER_HEADER_CATEGORY.COMPANY}
        />

        <div className="container">
          <ContinueSurvey isEnabled={locals.enableContinueSurvey} newVersion />
        </div>
        <div className="container z-mt-48">
          {showTimelineSection && (
            <section id="company-timeline">

              <CompanyTimelineSection
                headerContent={(
                  <div className="brandonH2 mb-5">
                    <h2
                      className={classNames('brandonH2', {
                        'd-inline align-middle z-mr-md-24 z-mr-sm-16 z-mr-xs-16': showJobsCount,
                      })}
                    >
                      {`${companyNameCPS} Company History Timeline`}
                    </h2>
                    {showJobsCount && (
                      <NoOfJobsButton
                        className="d-inline-block align-middle"
                        jobsCount={companyJobsCount}
                        href={buildCppSubpageUrl(companyLink, '', CPP_SUBPAGES.JOBS)}
                      />
                    )}
                  </div>
                )}
                companyLocation={companyLocation}
                companyLocationLink={companyLocationLink}
                companyFounders={companyFounders}
                companyTimeline={companyTimeline}
                companyFoundedDate={companyFoundedDate}
                onOpenMainCppSurvey={(src) => this.onOpenMainCppSurvey(src)}
                jobListDismiss={jobListDismiss}
                criteria={criteria}
                companyId={companyInfo.companyID}
                companyName={companyInfo.companyNameCPS}
                companyLogo={companyInfo.companyLogo}
                displayFlagOfCompanyJobsPage={displayFlagOfCompanyJobsPage}
              />
            </section>
          )}

          {!mainBucketProps.hideFallbackJobBucket && (
            <Fragment>
              <div className="section-separator-large" />
              <section
                data-title="JOBS"
                id="jobs"
                className={`company-page--jobs w-100 z-ml-0 testClassgroupA ${
                  !companyHistory ? 'z-mt-68 z-mt-md-88' : ''
                }`}
              >
                <div className="bucketBody bucketBodyWithFilter">
                  <JobContainer
                    bucketContainerClass="bucketListInnerBody"
                    userLocation={userLocation}
                    criteria={criteria}
                    filters={mainBucketFilters}
                    layout="bucket"
                    noCMPPage
                    isCppRemote
                    isDesktop={desktopDevice}
                    {...mainBucketProps}
                  />
                </div>
              </section>
            </Fragment>
          )}

          {companyHistory && (
            <CompanyHistorySection
              companyInfo={companyInfo}
              companyHistory={companyHistory}
              wikipediaPageUrl={companyWikipediaPageURL}
              sourceLinkText={merge_info.companyWikipediaPageURL}
              onOpenMainCppSurvey={this.onOpenMainCppSurvey}
              criteria={criteria}
              companyId={companyInfo.companyID}
              jobListDismiss={jobListDismiss}
            />
          )}

          {!!competitors?.length && (
            <Fragment>
              {(showTimelineSection || companyHistory) && (
                <div className="section-separator-large" />
              )}
              <section className={'w-730'}>
                <SimilarCompaniesSection
                  similarCompanies={competitors}
                  onOpenMainCppSurvey={this.onOpenMainCppSurvey}
                  companyNameCPS={companyNameCPS}
                  cppSubPageName={CPP_SUBPAGES.HISTORY}
                />
              </section>
            </Fragment>
          )}
          {!similarCompanyJobsBucket && !!competitors?.length && (
            <Fragment>
              <div className="section-separator-large" />
              <section
                data-title="COMPETITORS JOBS"
                id="competitors-jobs"
                className="w-100 z-ml-0 testClassgroupA"
              >
                <div className="bucketBody bucketBodyWithFilter">
                  <JobContainer
                    filters={this.setupCompanyCompetitorFilters()}
                    bucketContainerClass="bucketListInnerBody"
                    initialPayload={{
                      companyId: competitors.map(({ companyID }) => companyID),
                      excludeCompanies: [companyInfo.companyID],
                    }}
                    filterGroup={JOB_BUCKET_GROUP.CPP_SIMILAR_COMPANY_JOBS_BUCKET}
                    jobGroup={JOB_BUCKET_GROUP.CPP_SIMILAR_COMPANY_JOBS_BUCKET}
                    layout="bucket"
                    title={`${companyNameCPS} Similar Companies Jobs`}
                    isCppRemote
                    isDesktop={desktopDevice}
                  />
                </div>
              </section>
            </Fragment>
          )}

          <div className="section-separator-large" />

          {!!qnaData?.answers?.length && (
            <>
              <QuestionAndAnswerSection
                data={qnaData}
                padding={false}
                title={qnaData.sectionTitle}
                showBottomLink={false}
                showTopSeparator={false}
                hideFindJobsCallout
              />

              <div className="section-separator-large" />
            </>
          )}

          <CompanyClusterFooter linksData={footerSectionLinks} />
          <div className="section-separator-medium" />
          <div className="container">
            <BreadCrumbs
              breadCrumbs={breadCrumbs}
              lastUpdatedDate={lastUpdatedDate}
              containerClassName="container"
            />
          </div>

          <div className="section-separator-large pt-0" />
          <CompanyDisclaimerSection {...companyInfo} />
          <br />
        </div>
      </div>
    );
  }
}

CompanyHistoryPage.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any),
  locals: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = ({ modals, jobs, user }) => {
  const companyJobsBucket = jobs[JOB_BUCKET_GROUP.CPP_COMPANY_JOBS_BUCKET];
  const similarCompanyJobsBucket = jobs[JOB_BUCKET_GROUP.CPP_SIMILAR_COMPANY_JOBS_BUCKET];

  return {
    modals,
    hideMainJobBucket: companyJobsBucket
      ? companyJobsBucket.hideOnEmpty &&
        companyJobsBucket.totalJobs === 0 &&
        companyJobsBucket.loading === false &&
        !companyJobsBucket.error
      : false,
    similarCompanyJobsBucket: similarCompanyJobsBucket
      ? similarCompanyJobsBucket.hideOnEmpty &&
        similarCompanyJobsBucket.totalJobs === 0 &&
        similarCompanyJobsBucket.loading === false &&
        !similarCompanyJobsBucket.error
      : false,
    userLocation: user.userLocation,
    jobListDismiss: jobs.jobListDismiss,
  };
};

const mapDispatchToProps = {
  openSignUpModal,
  dispatchCreateJobBucket,
};

export default withFallbackToCompanyPaidJobs(
  withZippiaHistory(connect(mapStateToProps, mapDispatchToProps)(CompanyHistoryPage)),
  20,
  10,
  false
);
